<template>
  <el-row style="height: 680px;width: 100%;margin-top: 80px;">
    <el-row style="width: 100%;height: 100px;">
      <el-row class="about-us" />
    </el-row>
    <el-row class="document-class">
      <el-col style="width: 45%;height: 100%;">
        <el-row style="width: 100%;height: 310px;display: flex;justify-content: flex-end;">
          <el-row class="company-photo" />
        </el-row>
        <el-row style="width: 100%;height: calc(100% - 310px);display: flex;justify-content: flex-end;">
          <el-row class="company-info">{{companyInfo}}</el-row>
        </el-row>
      </el-col>
      <el-col style="width: 5%;border-right: 1px solid #999999;height: 100%;" />
      <el-col style="width: 35%;height: 100%;margin-left: 5%;">
<!--        <el-row style="height: 20%;width: 100%;display: flex;">-->
<!--          <el-col style="width: 45%;height: 100%;display: flex;">-->
<!--            <el-row class="v-class" />-->
<!--            <el-col style="width: calc(100% - 60px);margin-left: 10px;height: 100%;">-->
<!--              <el-row style="width: 100%;height: 50%;display: flex;">-->
<!--                <span style="font-size: 20px;height: 50px;line-height: 50px;color: #00bf86;">企业愿景</span>-->
<!--              </el-row>-->
<!--              <el-row style="text-align: justify;font-size: 16px;">{{v}}</el-row>-->
<!--            </el-col>-->
<!--          </el-col>-->
<!--          <el-col style="width: 45%;height: 100%;display: flex;margin-left: 5%;">-->
<!--            <el-row class="m-class" />-->
<!--            <el-col style="width: calc(100% - 60px);margin-left: 10px;height: 100%;">-->
<!--              <el-row style="width: 100%;height: 50%;display: flex;">-->
<!--                <span style="font-size: 20px;height: 50px;line-height: 50px;color: #00bf86;">我们的使命</span>-->
<!--              </el-row>-->
<!--              <el-row style="text-align: justify;font-size: 16px;">{{m}}</el-row>-->
<!--            </el-col>-->
<!--          </el-col>-->
<!--        </el-row>-->
        <el-row style="height: 100%;width: 100%;">
          <el-row class="about-us-ext" />
        </el-row>
<!--        <el-row style="height: 20%;width: 100%;display: flex;">-->
<!--          <el-col style="width: 45%;margin-left: 25%;height: 100%;display: flex;">-->
<!--            <el-row class="s-class" />-->
<!--            <el-col style="width: calc(100% - 60px);margin-left: 10px;height: 100%;">-->
<!--              <el-row style="width: 100%;height: 50%;display: flex;">-->
<!--                <span style="font-size: 20px;height: 50px;line-height: 50px;color: #00bf86;">价值观</span>-->
<!--              </el-row>-->
<!--              <el-row style="text-align: justify;font-size: 16px;">{{s}}</el-row>-->
<!--            </el-col>-->
<!--          </el-col>-->
<!--        </el-row>-->
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: 'AboutUs',
  data() {
    return {
      companyInfo: '瑜岿科技是一家专注于能源互联网、园区物联网产品及解决方案研发的创新型科技公司。为企业和集成商提供能源物联网云平台、智慧园区云平台、智能用电、多能互补、智慧运维、电能质量治理等系统解决方案以及相关的智能传感、测控装置。业务主要涉及以下三大领域：综合能源服务、智慧园区、分布式光伏。\n' +
        '坚持以客户为中心，以产品为核心，以创新为驱动，让绿色能源、智慧服务触手可及。',
      m: '致力于能源物联网的持续创新，让绿色能源触手可及。',
      v: '成为世界一流智慧能源整体解决方案提供商。',
      s: '客户第一，尊重人才，开拓创新，合作共赢。'
    }
  }
}
</script>

<style scoped>
  .about-us {
    background: url("../../assets/aboutus.png") no-repeat;
    width: 470px;
    margin-left: calc(50% - 235px);
    height: 100px;
    /*cursor: pointer;*/
  }
  .document-class {
    height: 500px;
    width: 100%;
    margin-top: 80px;
    display: flex;
  }
  .company-photo {
    background-image: url("../../assets/company.jpg");
    width: 610px;
    height: 310px;
    background-size: cover;
    /*cursor: pointer;*/
  }
  .company-info {
    margin-top: 12px;
    width: 610px;
    text-align: justify;
    line-height: 36px;
    white-space: pre-wrap;
  }
  .m-class {
    background: url("../../assets/m.png") no-repeat;
    width: 50px;
    height: 50px;
  }
  .v-class {
    background: url("../../assets/v.png") no-repeat;
    width: 50px;
    height: 50px;
  }
  .s-class {
    background: url("../../assets/s.png") no-repeat;
    width: 50px;
    height: 50px;
  }
  .about-us-ext {
    background: url("../../assets/aboutusext.png") no-repeat;
    width: 672px;
    /*margin-left: 16%;*/
    height: 504px;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/AboutUs.vue